import React, { useState } from "react";
import { Helmet } from "react-helmet"; // Import pour SEO
import { createTranslator, useLanguage } from '../i18n/LanguageContext';

const copy = {
  fr: { title: 'Offres de partenariat', visibility: 'Visibilité', benefits: 'Avantages de jeu', events: 'Événementiel', starter: 'Présence sur la page des partenaires et plusieurs inscriptions aux tournois ainsi qu’une inscription en ligue.', business: 'Logo prioritaire, visibilité sur les équipes, inscriptions aux tournois et ligues, et journée team building.', premium: 'Visibilité premium sur tous les supports, naming de ligues, inscriptions et journée dédiée aux partenaires.', notice: 'Ce formulaire sert à établir un premier contact et ne constitue aucun engagement contractuel.', contact: 'Contactez-nous', company: 'Nom de la société', manager: 'Nom du responsable', phone: 'Téléphone', email: 'Adresse e-mail', sector: 'Secteur d’activité', choose: 'Choisissez une offre', select: 'Sélectionnez une offre', send: 'Envoyer', success: 'Merci pour votre intérêt ! Notre équipe vous contactera rapidement.', method: 'Méthode non autorisée.', server: 'Erreur interne du serveur : ', unexpected: 'Une erreur inattendue est survenue : ', connection: 'Impossible de soumettre le formulaire. Vérifiez votre connexion ou contactez le support.' },
  de: { title: 'Partnerschaftsangebote', visibility: 'Sichtbarkeit', benefits: 'Spielvorteile', events: 'Veranstaltungen', starter: 'Präsenz auf der Partnerseite sowie mehrere Turnieranmeldungen und eine Liga-Anmeldung.', business: 'Bevorzugtes Logo, Sichtbarkeit auf Teamkleidung, Turnier- und Liga-Anmeldungen sowie ein Teambuilding-Tag.', premium: 'Premium-Sichtbarkeit auf allen Medien, Liga-Namensrechte, Anmeldungen und ein Partnertag.', notice: 'Dieses Formular dient nur der ersten Kontaktaufnahme und stellt keine vertragliche Verpflichtung dar.', contact: 'Kontaktiere uns', company: 'Unternehmen', manager: 'Ansprechpartner', phone: 'Telefon', email: 'E-Mail-Adresse', sector: 'Branche', choose: 'Angebot wählen', select: 'Angebot auswählen', send: 'Senden', success: 'Vielen Dank für dein Interesse! Unser Team meldet sich bald.', method: 'Methode nicht zulässig.', server: 'Interner Serverfehler: ', unexpected: 'Unerwarteter Fehler: ', connection: 'Formular konnte nicht gesendet werden. Bitte Verbindung prüfen oder Support kontaktieren.' },
  nl: { title: 'Partneraanbiedingen', visibility: 'Zichtbaarheid', benefits: 'Speelvoordelen', events: 'Evenementen', starter: 'Vermelding op de partnerpagina plus meerdere toernooi-inschrijvingen en één competitie-inschrijving.', business: 'Prominent logo, zichtbaarheid op teamkleding, inschrijvingen voor toernooien en competities, en een teambuildingdag.', premium: 'Premium zichtbaarheid op alle dragers, naamgeving van competities, inschrijvingen en een partnerdag.', notice: 'Dit formulier dient enkel voor een eerste contact en vormt geen contractuele verbintenis.', contact: 'Neem contact op', company: 'Bedrijfsnaam', manager: 'Naam contactpersoon', phone: 'Telefoon', email: 'E-mailadres', sector: 'Activiteitssector', choose: 'Kies een aanbieding', select: 'Selecteer een aanbieding', send: 'Verzenden', success: 'Bedankt voor je interesse! Ons team neemt snel contact op.', method: 'Methode niet toegestaan.', server: 'Interne serverfout: ', unexpected: 'Onverwachte fout: ', connection: 'Het formulier kon niet worden verzonden. Controleer je verbinding of neem contact op met support.' },
  en: { title: 'Partnership offers', visibility: 'Visibility', benefits: 'Playing benefits', events: 'Events', starter: 'Presence on the partner page plus several tournament registrations and one league registration.', business: 'Priority logo, visibility on team clothing, tournament and league registrations, and a team-building day.', premium: 'Premium visibility across all media, league naming, registrations and a dedicated partner day.', notice: 'This form is only for initial contact and does not constitute a contractual commitment.', contact: 'Contact us', company: 'Company name', manager: 'Contact person', phone: 'Phone', email: 'Email address', sector: 'Business sector', choose: 'Choose an offer', select: 'Select an offer', send: 'Send', success: 'Thank you for your interest! Our team will contact you shortly.', method: 'Method not allowed.', server: 'Internal server error: ', unexpected: 'An unexpected error occurred: ', connection: 'Unable to submit the form. Check your connection or contact support.' },
};

const OffresPartenariat = () => {
  const { language } = useLanguage();
  const t = createTranslator(language, copy);
  const [formData, setFormData] = useState({
    companyName: "",
    contactName: "",
    phone: "",
    email: "",
    sector: "",
    offer: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Changement détecté : ${name} = ${value}`);
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Données soumises :", formData);

    try {
      const response = await fetch("https://us-central1-mendyx-adafe.cloudfunctions.net/sendEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, language }),
      });

      if (response.status === 405) {
        alert(t('method'));
        console.error("Erreur 405 : Méthode non autorisée.");
      } else if (response.status === 500) {
        const errorText = await response.text();
        alert(t('server') + errorText);
        console.error("Erreur 500 :", errorText);
      } else if (response.ok) {
        alert(t('success'));
        setFormData({
          companyName: "",
          contactName: "",
          phone: "",
          email: "",
          sector: "",
          offer: "",
        });
      } else {
        const errorText = await response.text();
        alert(t('unexpected') + errorText);
        console.error("Erreur inattendue :", errorText);
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi :", error);
      alert(t('connection'));
    }
  };

  return (
    <>
    <Helmet>
      <title>Offres de Partenariat | Padel Mendyx</title>
      <meta
        name="description"
        content="Découvrez nos offres de partenariat : Starter, Business Pack, et Premium Sponsor. Contactez-nous pour devenir partenaire officiel de Padel Mendyx."
      />
      <meta
        name="keywords"
        content="partenariat Padel, offres partenaires, Starter, Business Pack, Premium Sponsor"
      />
      <meta property="og:title" content="Offres de Partenariat | Padel Mendyx" />
      <meta
        property="og:description"
        content="Explorez nos offres de partenariat et soutenez le développement du Padel en Belgique. Devenez un partenaire clé avec nos options flexibles."
      />
      <meta property="og:image" content="/partnership-page-preview.jpg" />
      <meta property="og:url" content="https://padelmedyx.com/offres-partenariat" />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://padelmedyx.com/offres-partenariat" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "OfferCatalog",
          "name": "Offres de Partenariat Padel Mendyx",
          "url": "https://padelmedyx.com/offres-partenariat",
          "offers": [
            {
              "@type": "Offer",
              "name": "Starter",
              "description": "Petit affichage sur le site web et plusieurs inscriptions à des tournois.",
              "priceCurrency": "EUR",
            },
            {
              "@type": "Offer",
              "name": "Business Pack",
              "description": "Affichage prioritaire, naming d'une catégorie, et journée de team building.",
              "priceCurrency": "EUR",
            },
            {
              "@type": "Offer",
              "name": "Premium Sponsor",
              "description": "Affichage premium, naming de plusieurs ligues, et présence sur les vêtements du staff.",
              "priceCurrency": "EUR",
            },
          ],
        })}
      </script>
    </Helmet>
    <section className="bg-gray-100 text-black py-16 px-4">
      <div className="container mx-auto text-center">
        <h1 className="text-4xl font-bold text-[#4c2f8e] mb-12">
          {t('title')}
        </h1>

        {/* Description des offres */}
        <div className="flex flex-wrap justify-center gap-8 mb-16">
  {/* Offre Starter */}
  <div className="bg-white shadow-md rounded-lg p-6 w-full sm:w-1/3">
    <h2 className="text-2xl font-semibold text-[#4c2f8e] mb-4">Starter</h2>
    <p className="text-gray-600 mb-2">
      <strong>{t('visibility')} :</strong> {t('starter')}
    </p>
    <p className="text-gray-600 mb-2">
      <strong>{t('benefits')} :</strong>
    </p>
 
  </div>

  {/* Offre Business Pack */}
  <div className="bg-white shadow-md rounded-lg p-6 w-full sm:w-1/3">
    <h2 className="text-2xl font-semibold text-[#4c2f8e] mb-4">Business Pack</h2>
    <p className="text-gray-600 mb-2">
      <strong>{t('visibility')} :</strong> {t('business')}
    </p>
    <p className="text-gray-600 mb-2">
      <strong>{t('benefits')} :</strong>
    </p>
    <p className="text-gray-600 mb-2">
      <strong>{t('events')} :</strong>
    </p>

  </div>

  {/* Offre Premium Sponsor */}
  <div className="bg-white shadow-md rounded-lg p-6 w-full sm:w-1/3">
    <h2 className="text-2xl font-semibold text-[#4c2f8e] mb-4">Premium Sponsor</h2>
    <p className="text-gray-600 mb-2">
      <strong>{t('visibility')} :</strong> {t('premium')}
    </p>
    <p className="text-gray-600 mb-2">
      <strong>Avantages de jeu :</strong> Inscriptions à des tournois et ligues.
    </p>
    <p className="text-gray-600 mb-2">
      <strong>Événementiel :</strong> Participation à une journée dédiée aux partenaires.
    </p>
  </div>
</div>

<p className="text-gray-600 text-sm mb-6">
  {t('notice')}
</p>


        {/* Formulaire */}
        <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-lg p-8 w-full sm:w-2/3 lg:w-1/2 mx-auto">
          <h2 className="text-2xl font-bold text-[#4c2f8e] mb-6">{t('contact')}</h2>

          {/* Nom de la société */}
          <input
            type="text"
            name="companyName"
            placeholder={t('company')}
            value={formData.companyName}
            onChange={handleChange}
            className="block w-full border border-gray-300 rounded-md p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]"
            required
          />

          {/* Nom du responsable */}
          <input
            type="text"
            name="contactName"
            placeholder={t('manager')}
            value={formData.contactName}
            onChange={handleChange}
            className="block w-full border border-gray-300 rounded-md p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]"
            required
          />

          {/* Téléphone */}
          <input
            type="tel"
            name="phone"
            placeholder={t('phone')}
            value={formData.phone}
            onChange={handleChange}
            className="block w-full border border-gray-300 rounded-md p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]"
            required
          />

          {/* Adresse email */}
          <input
            type="email"
            name="email"
            placeholder={t('email')}
            value={formData.email}
            onChange={handleChange}
            className="block w-full border border-gray-300 rounded-md p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]"
            required
          />

          {/* Secteur */}
          <input
            type="text"
            name="sector"
            placeholder={t('sector')}
            value={formData.sector}
            onChange={handleChange}
            className="block w-full border border-gray-300 rounded-md p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-[#4c2f8e]"
            required
          />

          {/* Liste déroulante pour choisir une offre */}
          <div className="text-left mb-6">
            <label className="block text-gray-700 text-base sm:text-lg mb-2 font-medium">
              {t('choose')} :
            </label>
            <select
              name="offer"
              value={formData.offer}
              onChange={handleChange}
              className="block w-full max-w-full border border-gray-300 rounded-md p-3 sm:p-4 mb-4 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-[#4c2f8e] transition duration-300 ease-in-out"
              required
            >
              <option value="" disabled>
                {t('select')}
              </option>
              <option value="Starter">Starter</option>
              <option value="Business Pack">Business Pack</option>
              <option value="Premium Sponsor">Premium Sponsor</option>
            </select>
          </div>

          {/* Bouton de soumission */}
          <button
            type="submit"
            className="block w-full py-3 bg-[#4c2f8e] text-white font-medium rounded-lg hover:bg-[#ea4c89] transition duration-300"
          >
            {t('send')}
          </button>
        </form>
      </div>
    </section>
    </>
  );
};

export default OffresPartenariat;
